module.exports = __webpack_public_path__ + "static/img/15.44d251d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/5/zh/15.png
// module id = Lufj
// module chunks = 0